import { Row } from "antd";
import Text from "components/Text";
import styled from "styled-components";

export const StyledRow = styled(Row)`
    margin-top: 10px;
`;
export const WorkDetailsWrapper = styled.div`
    background-color: #f9f9f9;
    width: 100%;
    padding: 20px 50px;

    @media only screen and (max-width: 700px) {
        padding: 35px 50px;
    }

    @media only screen and (max-width: 545px) {
        padding: 20px 30px;
    }
`;

export const HeaderSection = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 1rem;

    @media only screen and (max-width: 900px) {
        flex-direction: column;
        align-items: center;
        gap: 1rem;
    }
`;

export const HeaderText = styled.div`
    display: flex;
    flex-direction: column;
    gap: 5px;

    @media only screen and (max-width: 900px) {
        align-items: center;
        margin: 1rem 0;
    }
`;

export const TitleSection = styled.div`
    display: flex;
    align-items: center;
    gap: 5px;
    svg:first-of-type {
        font-size: 20px;
        cursor: pointer;
    }

    @media only screen and (max-width: 700px) {
        ${Text.Style} {
            font-size: 20px;
        }
    }
`;

export const ButtonRow = styled.div`
    display: flex;
    align-items: center;
    gap: 1rem;

    @media only screen and (max-width: 545px) {
        margin: 0 auto;
    }
`;

export const WorkDetailsContent = styled.div`
    display: flex;
    gap: 42px;

    @media only screen and (max-width: 1020px) {
        flex-direction: column;
    }
`;

export const ImageGrid = styled.div`
    display: flex;
    flex-wrap: wrap;
    max-width: 460px;
    gap: 17px;
    height: fit-content;
    @media only screen and (max-width: 1020px) {
        max-width: 100%;
        justify-content: space-between;
    }
    @media only screen and (max-width: 900px) {
        justify-content: center;
    }
`;

export const WorkImage = styled.img`
    border-radius: 16px;
    width: 220px;
    height: 220px;

    @media only screen and (max-width: 1200px) {
        width: 160px;
        height: 160px;
    }

    @media only screen and (max-width: 545px) {
        width: 100px;
        height: 100px;
    }
`;

export const ContentGrid = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    min-width: fit-content;
`;
export const ContainerParent = styled.div`
display:grid
grid-template-columns: 1fr 1fr
`;
export const ContentDivide = styled.div`
    width: 50%;
    float: left;
`;
export const ContentRow = styled.div<{
    spacing?: boolean;
    removeLeftPadding?: boolean;
}>`
    border-radius: 20px;
    background-color: #fff;
    padding: 18px 26px;
    padding-left: ${({ removeLeftPadding }) => removeLeftPadding && "0"};
    display: flex;
    justify-content: ${({ spacing }) => !spacing && "space-between"};
    align-items: center;
    gap: ${({ spacing }) => (spacing ? "2rem" : "1rem")};

    @media only screen and (max-width: 545px) {
        flex-wrap: wrap;
        width: 100%;
        margin: 0 auto;
    }
`;

export const AgencyInformation = styled.div<{
    spacing?: boolean;
    removeLeftPadding?: boolean;
}>`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${({ spacing }) => (spacing ? "2rem" : "1rem")};
`

export const ContentRowLeft = styled.div`
    display: flex;
    align-items: center;
    gap: 20px;
`;

export const ContentRowRight = styled.div`
    display: flex;
    align-items: center;
    gap: 20px;
`;
export const ContentCentre = styled.div`
    display: flex;
    justify-content: space-between;
`;
export const AgencyIcon = styled.img`
    width: 46px;
    height: 46px;
    border-radius: 50%;
`;

export const AgencyName = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
    margin-right: auto;
`;

export const InfoSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 5px;
`;

export const PreferenceSection = styled.div`
    border-radius: 20px;
    background-color: #fff;
    padding: 18px 26px;
`;
export const AgencySection = styled.div`
    border-radius: 20px;
    background-color: #fff;
    padding: 18px 26px;
`;
